import {
  Chip,
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { useNavigate } from "react-router-dom";
import { ResultList } from "core/types/search.types";
import { parse } from "date-fns";

interface Props {
  searchList?: ResultList[];
  isSearchLoading: boolean;
}

const ResearchListTable: FunctionComponent<Props> = ({
  searchList,
  isSearchLoading,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const linguaCorrente = i18n.language;

  return (
    <div style={{ overflowX: "auto" }}>
      {isSearchLoading ? (
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <CircularProgress color="secondary" size={"100px"} />
        </div>
      ) : (
        <TableContainer
          component={Paper}
          style={{
            position: "relative",
            borderRadius: "8px",
            maxHeight: "500px",
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>{t("searches.table.id")}</TableCell>
                <TableCell>{t("searches.table.full_name")}</TableCell>
                <TableCell>{t("searches.table.params")}</TableCell>
                <TableCell>{t("searches.table.made_on")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody
              sx={{
                "& .MuiTableCell-root": {
                  padding: "10px",
                  fontSize: "14px",
                },
              }}
            >
              {searchList?.map((search) => (
                <TableRow key={search.searchId}>
                  <TableCell>{search.searchId}</TableCell>
                  <TableCell>{search.fullName}</TableCell>
                  <TableCell>
                    <Grid container spacing={2}>
                      {search.params.map((p) => (
                        <Grid item>
                          <Chip label={p} />
                        </Grid>
                      ))}
                    </Grid>
                  </TableCell>
                  <TableCell>
                    {parse(
                      search.searchCreationTime,
                      "EEE, dd MMM yyyy HH:mm:ss 'GMT'",
                      new Date()
                    ).toLocaleDateString(
                      linguaCorrente === "en" ? "en-GB" : "it-IT",
                      { year: "numeric", month: "long", day: "numeric" }
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default ResearchListTable;
